// Which protocol XML belongs to which location + gate direction. This is the only location-specific
// item in the feature: everything else comes from the XML itself. `objectKey` is the full S3 object
// key; the bucket differs per environment (`VITE_PROTOCOLS_BASE_URL`).
const PROTOCOL_SOURCES = Object.freeze({
    // DHL (Dallas), location `dhl_dal` (same id in develop, staging and production)
    '108961418:IN': Object.freeze({ objectKey: 'dhl-dallas/protocol-dhl-dallas-in.xml' }),
    '108961418:OUT': Object.freeze({ objectKey: 'dhl-dallas/protocol-dhl-dallas-out.xml' }),
});

export function getProtocolKey(locationId, gateDirection) {
    if (locationId == null || locationId === '' || !gateDirection) return null;
    return `${locationId}:${gateDirection}`;
}

export function getProtocolSource(protocolKey) {
    if (!protocolKey) return null;
    return PROTOCOL_SOURCES[protocolKey] ?? null;
}

// The environment's protocols bucket root, read when called so tests can stub it. Empty when unset.
export function getProtocolsBaseUrl() {
    return import.meta.env.VITE_PROTOCOLS_BASE_URL ?? '';
}

// The object's URL in the environment's bucket, or `null` when the environment has no bucket.
export function getProtocolUrl(source) {
    const baseUrl = getProtocolsBaseUrl();
    if (!baseUrl || !source?.objectKey) return null;
    return `${baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`}${source.objectKey}`;
}

export function getGateDirectionFromProtocolKey(protocolKey) {
    const separatorIndex = protocolKey?.lastIndexOf(':') ?? -1;
    if (separatorIndex < 0) return null;
    return protocolKey.slice(separatorIndex + 1) || null;
}
